/**
 * Single analytics facade fanning out to GA4/GTM, Facebook Pixel and
 * CleverTap (migration plan §1.8 / §2.8), so feature code never touches
 * three separate global SDKs directly.
 *
 * GA4 (`G-N8SR598BB8`) and GTM (`GTM-KBQ8SGK`) scripts are loaded from
 * `index.html` to match the legacy `RF_Scholarship.aspx` landing page.
 * Facebook Pixel / CleverTap remain no-ops until those accounts are wired.
 */

export type AnalyticsEvent =
  | "eligibility_form_view"
  | "eligibility_form_submit"
  | "eligibility_form_success"
  | "eligibility_form_error"
  | "status_lookup_submit"
  | "status_lookup_result"

export function track(event: AnalyticsEvent, payload: Record<string, unknown> = {}) {
  if (import.meta.env.DEV) {
    console.info(`[analytics] ${event}`, payload)
  }

  window.gtag?.("event", event, payload)

  // Remaining production integration points (no-ops until scripts/IDs exist):
  // window.fbq?.("trackCustom", event, payload)
  // window.clevertap?.event.push(event, payload)
}

/**
 * SPA client-side navigations — initial page_view is already sent by
 * `gtag('config', …)` in `index.html`, so callers should skip the first mount.
 */
export function trackPageView(path: string) {
  if (import.meta.env.DEV) {
    console.info(`[analytics] page_view`, { path })
  }

  window.gtag?.("event", "page_view", { page_path: path })
}
